import {Button} from '@material-ui/core'
import React, {MouseEventHandler} from 'react'
import useStyles from './ReportsTableOverlayButton.styles'

type Props = {
  icon: React.ReactNode
  label: React.ReactNode
  href?: string
  onClick?: MouseEventHandler
  danger?: boolean
  'data-testid': string
}

function ReportsTableOverlayButton(props: Props) {
  const {icon, label, href, onClick, danger} = props
  const classes = useStyles()

  const rootClasses = [classes.root]
  if (danger) rootClasses.push(classes.danger)

  return (
    <Button
      className={rootClasses.join(' ')}
      onClick={onClick}
      href={href}
      data-testid={props['data-testid']}
    >
      <span className={classes.iconContainer}>{icon}</span>
      <span className={classes.labelContainer}>{label}</span>
    </Button>
  )
}

export default ReportsTableOverlayButton
